
export const LOAN_PRM_APPLICATION_WORKSPACE_VIEW = "applicant_dashboard_application_workspace_menu:visit"
export const LOAN_PRM_APPLICATION_APPROVED = "applicant_dashboard_application_approved:visit";
export const LOAN_PRM_APPLICATION_CLOSING = "applicant_dashboard_application_closing:visit";
export const LOAN_PRM_APPLICATION_LASER_PRO_HIDE = "advisor_application_runfn_pushed_to_laserpro:hide";
export const LOAN_PRM_APPLICATION_LASER_PRO_DISABLE = "advisor_application_runfn_pushed_to_laserpro:disable";
export const LOAN_PRM_APPLICATION_DISABLE_ASSIGN_APPROVER = "applicant_application_disable_assign_approver:visit";
export const LOAN_PRM_ADVISOR_CREDIT_APPROVAL_NEEDED = 'advisor_credit_approval_needed:visit'